<template>
    <div class="e3-folder-container d-flex flex-lg-column align-items-center" :title="file.name">
        <ImageThumbnail
            v-if="file.mime_type === 'image/jpeg' && file.thumbnails && file.thumbnails.small"
            :url="buildUrl()"/>
        <template v-else-if="videoMimeTypes.includes(file.mime_type)">
            <ImageThumbnail :url="checkThumbnail()">
                <PlayCircleOutlineIcon
                    v-if="hasThumbnail()"
                    class="video-play-icon text-white"/>
            </ImageThumbnail>
        </template>
        <div v-else class="e3-folder-box d-flex flex-lg-column align-items-center">
            <div @click="download(file)">
                {{ truncate(file.name, 20) }}
            </div>
        </div>
    </div>
</template>

<script>
import {truncate} from '@/filters';
import {mapGetters} from 'vuex';
import DocumentService from '@services/document.service';
import FileService from '@services/file.service';
import {downloadS3File} from '@services/helper.service';
import ImageThumbnail from '@components/image-thumbnail/ImageThumbnail.vue';
import PlayCircleOutlineIcon from '@components/svg-icons/PlayCircleOutlineIcon.vue';

export default {
    props: ['file', 'type'],
    data() {
        return {
            videoMimeTypes: ['video/mp4', 'video/quicktime']
        };
    },
    computed: {
        ...mapGetters(['activeKindergartenId'])
    },
    methods: {
        truncate, // TODO: Vue3 remove
        download(file) {
            if (file.url) {
                return downloadS3File(file.url, this.file);
            }

            if (this.type === 'document') {
                DocumentService.downloadDocument(this.activeKindergartenId, file);
            } else {
                FileService.getFile(file, this.type);
            }
        },
        buildUrl() {
            if (this.file.thumbnails.small.url) {
                return this.file.thumbnails.small.url;
            }

            if (this.type === 'child') {
                return `${process.env.VUE_APP_API_URL}/api/kindergartens/${this.activeKindergartenId}/children/${this.$route.params.child_id}/files_thumbs/${this.file.thumbnails.small.filename}`;
            } else {
                return `${process.env.VUE_APP_API_URL}/api/kindergartens/${this.activeKindergartenId}/files/${this.type}_thumbs/${this.file.thumbnails.small.filename}`;
            }
        },
        hasThumbnail() {
            return !!(this.file.thumbnails && this.file.thumbnails.small);
        },
        checkThumbnail() {
            if (this.hasThumbnail()) {
                return this.buildUrl();
            }
            return '/images/image_placeholder_video_thumbnail.jpg';
        }
    },
    components: {
        ImageThumbnail,
        PlayCircleOutlineIcon
    }
};
</script>

<style scoped lang="scss">
.video-play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60%;
    height: 60%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    opacity: 0.8;
}
</style>
